
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M491.7 156.3c-12.9-30.5-31.4-57.8-54.9-81.4-23.5-23.5-50.9-42-81.4-54.9-31.4-13.2-65-20-99.5-20s-68.1 6.8-99.6 20.1C125.8 33 98.5 51.5 75 75s-42 50.9-54.9 81.4C6.8 187.9 0 221.4 0 255.9s6.8 68.1 20.1 99.7C33 386.1 51.5 413.5 75 437s50.9 42 81.4 54.9C188 505.2 221.5 512 256 512s68.1-6.8 99.6-20.1c30.5-12.9 57.8-31.4 81.4-54.9 23.5-23.5 42-50.9 54.9-81.4 13.3-31.6 20.1-65.1 20.1-99.7 0-34.5-7-68-20.3-99.6zm-398 235.3c2-5.1 5.3-9.9 9.8-13.5 42-34.4 87-57.3 96.3-61.8 1-.5 1.7-1.6 1.7-2.7v-65.2c-8.2-5.5-13.6-14.8-13.6-25.4v-67.7c0-33.7 27.3-60.9 60.9-60.9h14.5c33.7 0 60.9 27.3 60.9 60.9V223c0 10.6-5.5 19.9-13.6 25.4v65.2c0 1.2.6 2.2 1.7 2.7 9.2 4.5 54.4 27.4 96.3 61.8 4.4 3.6 7.8 8.3 9.8 13.5-65.5 103-253.1 100.2-324.7 0z"}})])
          )
        }
      }
    